import { Column } from 'devextreme-react/data-grid';
import { formatMessage } from 'devextreme/localization';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Button, Template, TextBox } from 'devextreme-react';
import ScrollView from 'devextreme-react/scroll-view';
import { CustomRule, RequiredRule, Validator } from 'devextreme-react/validator';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import DataGridMVP from '../../DataGridMVP';
import SearchBar from '../../SearchBar/SearchBar';
import styles from './mailingAdmin.module.scss';
import columnDataGrid from './columnDataGrid';
import filterConfig from './filterConfig';
import PopupMVP from '../../PopupMVP';

const MailingAdmin = ({
  plantId,
  adminMailingReducer: {
    mailingList,
    mailingGet,
    dataAddMalling
  },
  getMailing,
  addMailing,
  addMailingClear
}) => {
  const [dataGridInstance, setDataGridInstance] = useState();
  const [inputValue, setInputValue] = useState('');
  const [filterData, setFilterData] = useState({});
  const [visibleModalMessageBody, setVisibleModalMessageBody] = useState(false);
  const [visibleModalForwardMessage, setVisibleForwardMessage] = useState(false);
  const [dataMailing, setDataMailing] = useState({});
  const [selectRowsMailing, setSelectRowsMailing] = useState({});

  useEffect(() => {
    getMailing({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plantId]);

  useEffect(() => {
    if (
      visibleModalForwardMessage
      && dataAddMalling.okRequest
    ) {
      setVisibleForwardMessage(false);
      addMailingClear();
    }
  }, [
    addMailingClear,
    visibleModalForwardMessage,
    dataAddMalling.okRequest
  ]);

  const openModalMessageBody = useCallback(() => {
    setVisibleModalMessageBody(true);
  }, []);

  const openModalForwardMessage = useCallback(() => {
    setVisibleForwardMessage(true);
    const { destinationEmail, id } = selectRowsMailing[0];
    setDataMailing({ recipients: destinationEmail, id });
  }, [selectRowsMailing]);

  const onHidingMessageBody = useCallback(() => {
    setVisibleModalMessageBody(false);
  }, []);

  const onHidingForwardMessage = useCallback(() => {
    setVisibleForwardMessage(false);
  }, []);

  const toolbarButtonMessageBody = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            text="См. тело сообщения"
            disabled={!selectRowsMailing.length}
            onClick={() => openModalMessageBody()}
    />
  ), [openModalMessageBody, selectRowsMailing]);

  const toolbarButtonForwardMessage = useMemo(() => () => (
    <Button type="default"
            stylingMode="contained"
            text="Переслать"
            disabled={!selectRowsMailing.length}
            onClick={() => openModalForwardMessage()}
    />
  ), [openModalForwardMessage, selectRowsMailing]);

  const sendSaveAddMailing = useCallback(() => {
    addMailing({
      filter: filterData,
      data: dataMailing
    });
  }, [addMailing, dataMailing, filterData]);

  const onSelectMailing = useCallback(({ selectedRowsData }) => {
    setSelectRowsMailing(selectedRowsData);
  }, []);

  const onResetFilter = useCallback(() => {
    if (inputValue) {
      getMailing({ text: inputValue });
    } else {
      getMailing({});
    }
  }, [getMailing, inputValue]);

  const onSaveFilter = useCallback(() => {
    getMailing({ ...filterData, text: inputValue });
  }, [filterData, getMailing, inputValue]);

  const onClickSearch = useCallback(() => {
    if (inputValue) {
      getMailing({ ...filterData, text: inputValue });
    } else {
      getMailing(filterData);
    }
  }, [filterData, getMailing, inputValue]);

  const onCancelText = useCallback(() => {
    getMailing(filterData);
  }, [filterData, getMailing]);

  const validateEmails = useCallback((data) => {
    const emails = data.value.split(',');
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isValid = true;
    emails.forEach((email) => {
      if (!regex.test(email)) {
        isValid = false;
      }
    });
    return isValid;
  }, []);

  const renderColumnDataGrid = useMemo(
    () =>
      columnDataGrid.map((item) => (
        <Column
          dataField={item.dataField}
          caption={formatMessage('textTableAdminMailing')[item.dataField]}
          visible={!item.notVisible}
          allowFiltering
          cellRender={item.cellRender}
          key={item.dataField}
          dataType={item.dataType}
          cssClass={item.cssClass}
        />
      )),
    []
  );

  const renderModalMessageBody = useMemo(() => (
    <PopupMVP visible={visibleModalMessageBody}
            onHiding={onHidingMessageBody}
            title="Тело сообщения"
    >
      <ScrollView elementAttr={{ class: styles.itemScroll }}
                  showScrollbar="always">
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={
          { __html: selectRowsMailing.length && selectRowsMailing[0].body }
        } />
      </ScrollView>
    </PopupMVP>
  ), [onHidingMessageBody, selectRowsMailing, visibleModalMessageBody]);

  const renderModalForwardMessage = useMemo(() => (
    <PopupMVP visible={visibleModalForwardMessage}
            onHiding={onHidingForwardMessage}
            title="Переслать сообщение"
    >
      <div className="formData">
        <div className="optionsData">
          <span>
            Получатель
            <sup>*</sup>
          </span>
          <TextBox stylingMode="outlined"
                   placeholder="Введите email"
                   value={dataMailing && dataMailing.recipients}
                   onValueChanged={({ value }) => {
                     setDataMailing((item) => ({
                       ...item,
                       recipients: value
                     }));
                   }}
          >
            <Validator>
              <CustomRule
                validationCallback={validateEmails}
                message="Введите один или несколько корректных email-адресов, разделенных запятой без пробела"
              />
              <RequiredRule message="Обязательно для ввода" />
            </Validator>
          </TextBox>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingForwardMessage}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddMailing}
                  width={200}
           >
            <LoadIndicator className="indicator" visible={dataAddMalling.loading} />
            <span>Переслать</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalForwardMessage,
    onHidingForwardMessage,
    dataMailing,
    sendSaveAddMailing,
    dataAddMalling.loading,
    validateEmails
  ]);

  return (
    <>
      <div className={styles.tabHeading}>
        <SearchBar
          inputValue={inputValue}
          setInputValue={setInputValue}
          filterData={filterData}
          setFilterData={setFilterData}
          dataGridInstance={dataGridInstance}
          onResetFilter={onResetFilter}
          onSaveFilter={onSaveFilter}
          filterConfig={filterConfig}
          onClickSearch={onClickSearch}
          onCancel={onCancelText}
        />
      </div>
      <div className={styles.dataGridWrapper}>
        <DataGridMVP
          dataSource={mailingList}
          setDataGridInstance={setDataGridInstance}
          keyExpr="id"
          setStateStoringName={'dataGridMailing'}
          isDataLoading={mailingGet.loading}
          visibleButtonDateRangePicker={false}
          tText={formatMessage('textPeriod')}
          selectionMode="single"
          visibleButtonAddResponsiblePerson
          visibleButtonPersonVisit
          visibleSearchPanel={false}
          visibleInfoIcon={false}
          visibleSummary={false}
          visibleGroupPanel={false}
          filterDataGrid
          onSelectionChanged={onSelectMailing}
        >
          {renderColumnDataGrid}
          <Template name="toolbarButtonAddResponsiblePerson" render={toolbarButtonMessageBody} />
          <Template name="toolbarButtonVisitResponsiblePerson" render={toolbarButtonForwardMessage} />
        </DataGridMVP>
      </div>
      {renderModalMessageBody}
      {renderModalForwardMessage}
    </>
  );
};

export default React.memo(MailingAdmin);
